import { cn } from "@/lib/utils";

interface PolicyStudioEmptyProps {
  className?: string;
}

export function PolicyStudioEmpty({ className }: PolicyStudioEmptyProps) {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M60 18 L88 30 L88 62 Q88 84 60 96 Q32 84 32 62 L32 30 Z"
        style={{ fill: "hsl(var(--muted))", stroke: "hsl(var(--primary))" }}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle
        cx="56"
        cy="60"
        r="7"
        style={{ fill: "none", stroke: "hsl(var(--primary))" }}
        strokeWidth="1.5"
      />
      <line
        x1="61"
        y1="65"
        x2="70"
        y2="74"
        style={{ stroke: "hsl(var(--primary))" }}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <line
        x1="68"
        y1="70"
        x2="68"
        y2="76"
        style={{ stroke: "hsl(var(--primary))" }}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="65"
        y1="73"
        x2="65"
        y2="77"
        style={{ stroke: "hsl(var(--primary))" }}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
